import React from "react";
import Button from "./Button";

export default class TrowFragment extends React.Component {
  onEvent = (date) => {
    this.props.onEvent(this.props.dir);
  }

  render() {
    return (
      <div className="trow">
        <button onClick={this.onEvent}>{this.props.dir}</button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/TrowFragment.js